// Subcategory translations for EN, NL, ES
// Used by getSubcategoryTranslation() helper

export const SUBCATEGORY_TRANSLATIONS = {
  // Real Estate
  "House": { nl: "Huis", es: "Casa" },
  "Villa": { nl: "Villa", es: "Villa" },
  "Apartments": { nl: "Appartementen", es: "Apartamentos" },
  "Land": { nl: "Grond", es: "Terreno" },
  "Commercial Property": { nl: "Commercieel Vastgoed", es: "Propiedad Comercial" },
  "Monument": { nl: "Monument", es: "Monumento" },
  "Property Wanted": { nl: "Vastgoed Gezocht", es: "Propiedad Buscada" },
  "Rental": { nl: "Verhuur", es: "Alquiler" },
  
  // Vehicles
  "Cars": { nl: "Auto's", es: "Coches" },
  "Motorcycles": { nl: "Motoren", es: "Motos" },
  "SUVs / Pickups": { nl: "SUV's / Pickups", es: "SUVs / Pickups" },
  "Vehicle Parts / Accessories": { nl: "Voertuigonderdelen", es: "Piezas de Vehículos" },
  "Rental / Leasing": { nl: "Verhuur / Lease", es: "Alquiler / Leasing" },
  "Taxis / Transfers": { nl: "Taxi's / Transfers", es: "Taxis / Traslados" },
  
  // Boats & Marine
  "Boats & Yachts": { nl: "Boten & Jachten", es: "Barcos y Yates" },
  "Jet Skis & Jetboats": { nl: "Jetski's & Jetboten", es: "Motos de Agua" },
  "Kayaks & Paddles": { nl: "Kajaks & Peddels", es: "Kayaks y Remos" },
  "Fishing Gear & Boats": { nl: "Visuitrusting & Boten", es: "Equipo de Pesca" },
  "Boat Parts & Accessories": { nl: "Bootonderdelen", es: "Accesorios Náuticos" },
  "Outdoor & Marine Wanted": { nl: "Outdoor & Marine Gezocht", es: "Exterior y Marino Buscado" },
  
  // Electronics
  "Smartphones": { nl: "Smartphones", es: "Teléfonos" },
  "Laptops & Computers": { nl: "Laptops & Computers", es: "Portátiles y Ordenadores" },
  "Tablets": { nl: "Tablets", es: "Tabletas" },
  "TV & Audio": { nl: "TV & Audio", es: "TV y Audio" },
  "Printers & Scanners": { nl: "Printers & Scanners", es: "Impresoras y Escáneres" },
  
  // Fashion
  "Men's Clothing": { nl: "Herenkleding", es: "Ropa de Hombre" },
  "Women's Clothing": { nl: "Dameskleding", es: "Ropa de Mujer" },
  "Kids & Baby Clothing": { nl: "Kinder- & Babykleding", es: "Ropa de Niños" },
  "Shoes": { nl: "Schoenen", es: "Zapatos" },
  "Bags & Handbags": { nl: "Tassen", es: "Bolsos" },
  "Jewelry": { nl: "Sieraden", es: "Joyería" },
  "Watches": { nl: "Horloges", es: "Relojes" },
  "Sunglasses & Accessories": { nl: "Zonnebrillen & Accessoires", es: "Gafas de Sol" },
  "Designer / Luxury Fashion": { nl: "Designer / Luxe Mode", es: "Moda de Diseñador" },
  "Sportswear": { nl: "Sportkleding", es: "Ropa Deportiva" },
  
  // Furniture
  "Living Room": { nl: "Woonkamer", es: "Sala de Estar" },
  "Bedroom": { nl: "Slaapkamer", es: "Dormitorio" },
  "Beds & Mattresses": { nl: "Bedden & Matrassen", es: "Camas y Colchones" },
  "Tables & Dining Sets": { nl: "Tafels & Eetsets", es: "Mesas y Comedores" },
  "Chairs": { nl: "Stoelen", es: "Sillas" },
  "Sofas & Couches": { nl: "Banken", es: "Sofás" },
  "Cabinets & Storage": { nl: "Kasten & Opslag", es: "Armarios" },
  "Wardrobes & Dressers": { nl: "Kledingkasten", es: "Roperos" },
  "Office Furniture": { nl: "Kantoormeubilair", es: "Muebles de Oficina" },
  "Outdoor / Patio Furniture": { nl: "Tuinmeubilair", es: "Muebles de Jardín" },
  "Kids Furniture": { nl: "Kindermeubilair", es: "Muebles Infantiles" },
  "Furniture Sets": { nl: "Meubelsets", es: "Conjuntos de Muebles" },
  "Lighting": { nl: "Verlichting", es: "Iluminación" },
  "Bathroom": { nl: "Badkamer", es: "Baño" },
  "Kitchen": { nl: "Keuken", es: "Cocina" },

  // Sports & Outdoor
  "Fitness Equipment": { nl: "Fitnessapparatuur", es: "Equipos de Fitness" },
  "Sports Equipment": { nl: "Sportuitrusting", es: "Equipos Deportivos" },
  "Bikes & Cycling": { nl: "Fietsen", es: "Bicicletas" },
  "Surfing, Kite & SUP": { nl: "Surfen, Kite & SUP", es: "Surf, Kite y SUP" },
  "Diving & Snorkeling": { nl: "Duiken & Snorkelen", es: "Buceo y Snorkel" },
  "Camping & Hiking": { nl: "Kamperen & Wandelen", es: "Camping y Senderismo" },
  "Beach & Swimming Gear": { nl: "Strand- & Zwemspullen", es: "Equipo de Playa" },
  "BBQ & Outdoor Cooking": { nl: "BBQ & Buiten Koken", es: "BBQ y Cocina Exterior" },
  "Garden & Yard Equipment": { nl: "Tuin- & Erfapparatuur", es: "Equipos de Jardín" },
  
  // Baby & Kids
  "Toys": { nl: "Speelgoed", es: "Juguetes" },
  "Baby Gear": { nl: "Babyspullen", es: "Artículos de Bebé" },
  "Strollers": { nl: "Kinderwagens", es: "Cochecitos" },
  
  // Pets
  "Dogs": { nl: "Honden", es: "Perros" },
  "Cats": { nl: "Katten", es: "Gatos" },
  "Pets": { nl: "Huisdieren", es: "Mascotas" },
  "Pets for Sale": { nl: "Huisdieren te Koop", es: "Mascotas en Venta" },
  "Pet Supplies": { nl: "Dierenbenodigdheden", es: "Suministros para Mascotas" },
  "Pet Services": { nl: "Huisdierdiensten", es: "Servicios para Mascotas" },
  "Pets Rescue": { nl: "Dierenredding", es: "Rescate de Mascotas" },
  "Other Rescue": { nl: "Andere Redding", es: "Otro Rescate" },
  
  // Beauty & Health
  "Skincare": { nl: "Huidverzorging", es: "Cuidado de la Piel" },
  "Hair Products": { nl: "Haarproducten", es: "Productos para el Cabello" },
  "Beauty Products": { nl: "Schoonheidsproducten", es: "Productos de Belleza" },
  "Beauty & Wellness": { nl: "Beauty & Wellness", es: "Belleza y Bienestar" },
  "Treatments": { nl: "Behandelingen", es: "Tratamientos" },
  
  // Business & Industrial
  "Business Equipment": { nl: "Bedrijfsapparatuur", es: "Equipos Comerciales" },
  "Restaurant Equipment": { nl: "Restaurantapparatuur", es: "Equipos de Restaurante" },
  "Heavy Machinery": { nl: "Zware Machines", es: "Maquinaria Pesada" },
  "Industrial Tools": { nl: "Industrieel Gereedschap", es: "Herramientas Industriales" },
  "Solar & Energy": { nl: "Zonne-energie", es: "Solar y Energía" },
  "Security": { nl: "Beveiliging", es: "Seguridad" },
  
  // Services
  "Home Services (cleaning, repairs, plumbing)": { nl: "Huisdiensten (schoonmaak, reparaties)", es: "Servicios del Hogar" },
  "Construction & Renovation": { nl: "Bouw & Renovatie", es: "Construcción y Renovación" },
  "Moving & Transport": { nl: "Verhuizen & Transport", es: "Mudanzas y Transporte" },
  "Event Services": { nl: "Evenementdiensten", es: "Servicios de Eventos" },
  "Photography & Video": { nl: "Fotografie & Video", es: "Fotografía y Vídeo" },
  "Business Services": { nl: "Zakelijke Diensten", es: "Servicios Empresariales" },
  "Freelance Services": { nl: "Freelance Diensten", es: "Servicios Freelance" },
  "IT & Tech Services": { nl: "IT & Tech Diensten", es: "Servicios IT y Tech" },
  "Marketing & Design": { nl: "Marketing & Design", es: "Marketing y Diseño" },
  "Lessons & Tutoring": { nl: "Lessen & Bijles", es: "Clases y Tutorías" },
  "Professional": { nl: "Professioneel", es: "Profesional" },
  "Watersports Lessons & Rentals": { nl: "Watersportlessen & Verhuur", es: "Clases y Alquiler de Deportes Acuáticos" },
  "Services Wanted (people looking for help)": { nl: "Diensten Gezocht", es: "Servicios Buscados" },
  
  // Jobs
  "Full-time": { nl: "Voltijd", es: "Tiempo Completo" },
  "Part-time": { nl: "Deeltijd", es: "Tiempo Parcial" },
  "Freelance": { nl: "Freelance", es: "Freelance" },
  "Internships": { nl: "Stages", es: "Prácticas" },
  "Remote Jobs": { nl: "Remote Werk", es: "Trabajo Remoto" },
  "Student Jobs": { nl: "Studentenbanen", es: "Trabajos para Estudiantes" },
  "Hospitality & Tourism": { nl: "Horeca & Toerisme", es: "Hostelería y Turismo" },
  "Sales & Retail Jobs": { nl: "Verkoop & Retail", es: "Ventas y Retail" },
  "IT & Tech Jobs": { nl: "IT & Tech Banen", es: "Trabajos IT y Tech" },
  "Healthcare Jobs": { nl: "Zorgbanen", es: "Trabajos de Salud" },
  "Construction Jobs": { nl: "Bouwbanen", es: "Trabajos de Construcción" },
  "Driver & Delivery Jobs": { nl: "Chauffeur & Bezorging", es: "Conductor y Entregas" },
  "Office & Administration": { nl: "Kantoor & Administratie", es: "Oficina y Administración" },
  "Customer Service": { nl: "Klantenservice", es: "Servicio al Cliente" },
  "Marketing & Media Jobs": { nl: "Marketing & Media", es: "Marketing y Medios" },
  "Cleaning & Maintenance Jobs": { nl: "Schoonmaak & Onderhoud", es: "Limpieza y Mantenimiento" },
  "Jobs Wanted (people looking for work)": { nl: "Werk Gezocht", es: "Busco Trabajo" },
  
  // Tours & Experiences
  "Island Tours": { nl: "Eilandtours", es: "Tours por la Isla" },
  "Boat Tours": { nl: "Boottours", es: "Tours en Barco" },
  "Diving Tours": { nl: "Duiktours", es: "Tours de Buceo" },
  "Snorkeling Tours": { nl: "Snorkeltours", es: "Tours de Snorkel" },
  "Nature & Wildlife Tours": { nl: "Natuur & Wildlife Tours", es: "Tours de Naturaleza" },
  "City Tours": { nl: "Stadstours", es: "Tours por la Ciudad" },
  "Cultural & Historical Tours": { nl: "Culturele & Historische Tours", es: "Tours Culturales" },
  "Adventure Tours": { nl: "Avontuurtours", es: "Tours de Aventura" },
  "Sunset Cruises": { nl: "Zonsondergang Cruises", es: "Cruceros al Atardecer" },
  "Private Tours": { nl: "Privétours", es: "Tours Privados" },
  "Group Tours": { nl: "Groepstours", es: "Tours en Grupo" },
  
  // Tickets
  "Concert Tickets": { nl: "Concertkaartjes", es: "Entradas de Conciertos" },
  "Sports Tickets": { nl: "Sportkaartjes", es: "Entradas Deportivas" },
  "Event Tickets": { nl: "Evenementkaartjes", es: "Entradas de Eventos" },
  "Boat Tickets": { nl: "Bootkaartjes", es: "Billetes de Barco" },
  "Fuik Boat Tickets": { nl: "Fuik Bootkaartjes", es: "Billetes Fuik" },
  
  // Community
  "Lost & Found": { nl: "Verloren & Gevonden", es: "Perdido y Encontrado" },
  "Lost and Found": { nl: "Verloren & Gevonden", es: "Perdido y Encontrado" },
  "Free Items": { nl: "Gratis Spullen", es: "Artículos Gratis" },
  "Donations": { nl: "Donaties", es: "Donaciones" },
  "Community Items": { nl: "Gemeenschapsspullen", es: "Artículos Comunitarios" },
  "Barter / Trade": { nl: "Ruilen", es: "Trueque" },
  "Wanted (looking for something)": { nl: "Gezocht", es: "Buscado" },
  "Announcements": { nl: "Aankondigingen", es: "Anuncios" },
  
    // Music
  "Musical Instruments": { nl: "Muziekinstrumenten", es: "Instrumentos musicales" },
  "Audio & Studio Equipment": { nl: "Audio & Studio Apparatuur", es: "Equipos de audio" },
  "Accessories & Other": { nl: "Accessoires & Overig", es: "Accesorios y otros" },

  // General
  "Other": { nl: "Overig", es: "Otro" },
  "Miscellaneous": { nl: "Diversen", es: "Misceláneo" },
};

// Category name translations (by English name)
export const CATEGORY_TRANSLATIONS = {
  "Real Estate": { nl: "Vastgoed", es: "Bienes Raíces" },
  "Vehicles": { nl: "Voertuigen", es: "Vehículos" },
  "Boats & Marine": { nl: "Boten & Marine", es: "Barcos y Náutica" },
  "Electronics": { nl: "Elektronica", es: "Electrónica" },
  "Fashion": { nl: "Mode", es: "Moda" },
  "Furniture": { nl: "Meubels", es: "Muebles" },
  "Sports & Outdoor": { nl: "Sport & Outdoor", es: "Deportes y Exterior" },
  "Baby & Kids": { nl: "Baby & Kinderen", es: "Bebés y Niños" },
  "Kids & Baby": { nl: "Baby & Kinderen", es: "Bebés y Niños" },
  "Pets": { nl: "Huisdieren", es: "Mascotas" },
  "Beauty & Health": { nl: "Beauty & Gezondheid", es: "Belleza y Salud" },
  "Health & Beauty": { nl: "Beauty & Gezondheid", es: "Belleza y Salud" },
  "Business & Industrial": { nl: "Zakelijk & Industrieel", es: "Negocios e Industrial" },
  "Services": { nl: "Diensten", es: "Servicios" },
  "Jobs": { nl: "Vacatures", es: "Empleos" },
  "Tours & Experiences": { nl: "Tours & Ervaringen", es: "Tours y Experiencias" },
  "Tours": { nl: "Tours", es: "Tours" },
  "Tickets": { nl: "Tickets", es: "Entradas" },
  "Community": { nl: "Community", es: "Comunidad" },
  "Yard Sale": { nl: "Garageverkoop", es: "Venta de Garaje" },
  "Music": { nl: "Muziek", es: "Música" },
  "Watersport": { nl: "Watersport", es: "Deportes Acuáticos" },
  "Other": { nl: "Overig", es: "Otros" },
  "Construction & Tools": { nl: "Bouw & Gereedschap", es: "Construcción y Herramientas" },
};

// Category ID to translations mapping (for when we only have the slug ID)
export const CATEGORY_ID_TRANSLATIONS = {
  "real-estate": { en: "Real Estate", nl: "Vastgoed", es: "Bienes Raíces" },
  "vehicles": { en: "Vehicles", nl: "Voertuigen", es: "Vehículos" },
  "electronics": { en: "Electronics", nl: "Elektronica", es: "Electrónica" },
  "fashion": { en: "Fashion", nl: "Mode", es: "Moda" },
  "furniture": { en: "Furniture", nl: "Meubels", es: "Muebles" },
  "services": { en: "Services", nl: "Diensten", es: "Servicios" },
  "jobs": { en: "Jobs", nl: "Vacatures", es: "Empleos" },
  "watersport": { en: "Watersport", nl: "Watersport", es: "Deportes Acuáticos" },
  "tours": { en: "Tours", nl: "Tours", es: "Tours" },
  "other": { en: "Other", nl: "Overig", es: "Otros" },
  "tickets": { en: "Tickets", nl: "Tickets", es: "Entradas" },
  "pets": { en: "Pets", nl: "Huisdieren", es: "Mascotas" },
  "kid&baby": { en: "Kids & Baby", nl: "Baby & Kinderen", es: "Bebés y Niños" },
  "baby-kids": { en: "Baby & Kids", nl: "Baby & Kinderen", es: "Bebés y Niños" },
  "business&industrial": { en: "Business & Industrial", nl: "Zakelijk & Industrieel", es: "Negocios e Industrial" },
  "health&beauty": { en: "Health & Beauty", nl: "Beauty & Gezondheid", es: "Belleza y Salud" },
  "construction-&-tools": { en: "Construction & Tools", nl: "Bouw & Gereedschap", es: "Construcción y Herramientas" },
  "outdoor-sports": { en: "Sports & Outdoor", nl: "Sport & Outdoor", es: "Deportes y Exterior" },
  "art-collectibles": { en: "Art & Collectibles", nl: "Kunst & Verzamelobjecten", es: "Arte y Coleccionables" },
  "music": { en: "Music", nl: "Muziek", es: "Música" },
  "community": { en: "Community", nl: "Community", es: "Comunidad" },
  "yard-sale": { en: "Yard Sale", nl: "Garageverkoop", es: "Venta de Garaje" },
};

/**
 * Format a slug-style ID into a human-readable name
 * e.g., "baby-gear-&-strollers" -> "Baby Gear & Strollers"
 * 
 * @param {string} slug - The slug-style ID
 * @returns {string} - Formatted name
 */
function formatSlugToName(slug) {
  if (!slug) return '';
  return slug
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
    .replace(/\s+&\s+/g, ' & ') // Clean up "& " spacing
    .replace(/\s+/g, ' ') // Remove extra spaces
    .trim();
}

/**
 * Get translated subcategory name
 * Supports both:
 * - String input (uses hardcoded SUBCATEGORY_TRANSLATIONS as fallback)
 * - Object input with {en, nl, es} structure (from database)
 * 
 * @param {string|object} subcategory - Subcategory name (string) or name object {en, nl, es}
 * @param {string} language - Target language (en, nl, es)
 * @returns {string} - Translated name or original if not found
 */
export function getSubcategoryTranslation(subcategory, language) {
  if (!subcategory) return '';
  
  // If subcategory is an object with translations (from database)
  if (typeof subcategory === 'object' && subcategory !== null) {
    return subcategory[language] || subcategory.en || subcategory.nl || Object.values(subcategory)[0] || '';
  }
  
  // Normalize apostrophes: replace typographic apostrophe (U+2019) with straight apostrophe (U+0027)
  const normalizedSubcategory = subcategory.replace(/[\u2018\u2019\u201B]/g, "'");
  
  // Try to find a translation in the hardcoded map
  const translation = SUBCATEGORY_TRANSLATIONS[normalizedSubcategory] || SUBCATEGORY_TRANSLATIONS[subcategory];
  
  if (translation && translation[language]) {
    return translation[language];
  }
  
  // For English, check if it looks like a slug (contains dashes) and format it
  if (language === 'en') {
    if (subcategory.includes('-')) {
      return formatSlugToName(subcategory);
    }
    return subcategory; // Already a proper name
  }
  
  // For NL/ES: if no translation found, try formatting the slug for better display
  if (subcategory.includes('-')) {
    return formatSlugToName(subcategory);
  }
  
  return subcategory; // Fallback to original
}

/**
 * Get translated category name
 * Supports:
 * - Object input with {en, nl, es} structure (from database)
 * - String input: English name (uses CATEGORY_TRANSLATIONS)
 * - String input: slug ID (uses CATEGORY_ID_TRANSLATIONS)
 * 
 * @param {string|object} category - Category name (string), ID (string), or name object {en, nl, es}
 * @param {string} language - Target language (en, nl, es)
 * @returns {string} - Translated name or formatted original if not found
 */
export function getCategoryTranslation(category, language) {
  if (!category) return '';
  
  // If category is an object with translations (from database)
  if (typeof category === 'object' && category !== null) {
    // Try requested language, then English, then first available
    return category[language] || category.en || category.nl || Object.values(category)[0] || '';
  }
  
  // First try: look up by ID in CATEGORY_ID_TRANSLATIONS (for slug-style IDs like "vehicles", "kid&baby")
  const idTranslation = CATEGORY_ID_TRANSLATIONS[category.toLowerCase()];
  if (idTranslation) {
    return idTranslation[language] || idTranslation.en || category;
  }
  
  // Second try: look up by English name in CATEGORY_TRANSLATIONS
  const nameTranslation = CATEGORY_TRANSLATIONS[category];
  if (nameTranslation) {
    if (language === 'en') return category;
    return nameTranslation[language] || category;
  }
  
  // Fallback: format slug to readable name
  if (category.includes('-') || category.includes('&')) {
    return formatSlugToName(category);
  }
  
  return category; // Return original
}

/**
 * Helper to get category name from a category object (from API)
 * Use this when you have the full category object from the database
 * 
 * @param {object} categoryObj - Full category object with name: {en, nl, es}
 * @param {string} language - Target language (en, nl, es)
 * @returns {string} - Translated name
 */
export function getCategoryNameFromObject(categoryObj, language) {
  if (!categoryObj) return '';
  
  // If categoryObj has a name object with translations
  if (categoryObj.name && typeof categoryObj.name === 'object') {
    return categoryObj.name[language] || categoryObj.name.en || categoryObj.name.nl || '';
  }
  
  // If categoryObj.name is a string (legacy)
  if (typeof categoryObj.name === 'string') {
    return getCategoryTranslation(categoryObj.name, language);
  }
  
  // Fallback to id
  return categoryObj.id || '';
}
